import { Api } from '../api';
import { IListagemCampanha, IDetalheCampanha, IListagemStatusCampanha, IListagemUsuariosCampanha, IListagemCampanhaSimples } from 'shared/types';


const getAll = async (org: number, filter = '' ): Promise<IListagemCampanha[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/campanhas${filter}`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getSimples = async (org: number, filter = '' ): Promise<IListagemCampanhaSimples[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/campanhas/simples${filter}`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (org: number, id: number): Promise<IDetalheCampanha | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${org}/campanhas/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};

const create = async (org: number, dados: Omit<IDetalheCampanha, 'idCampanha'>): Promise<number | Error> => {
  try {
    const { data } = await Api.post<IDetalheCampanha>(`/Orgs/${org}/campanhas/`, dados);

    if (data) {
      return Number(data.IdCampanha);
    }

    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (org: number, id: number, dados: IDetalheCampanha,): Promise<void | Error> => {
  try {
    await Api.put(`/Orgs/${org}/campanhas/${id}`, dados);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};

const deleteById = async (org: number, id: number): Promise<void | Error> => {
  try {
    await Api.delete(`/Orgs/${org}/campanhas/${id}`);
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

const getStatus = async (org: number): Promise<IListagemStatusCampanha[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/campanhas/status`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getUsers = async (org: number): Promise<IListagemUsuariosCampanha[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/campanhas/usuarios`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};


export const CampanhasService = {
  getAll,
  getSimples,
  create,
  getById,
  updateById,
  deleteById,
  getStatus,
  getUsers,
};
